export const fields = [
  { name: "type", required: true },
  { name: "name" },
  { name: "street", required: true },
  { name: "city" },
  { name: "postal_code", required: true },
  { name: "country_code", required: true },
  { name: "lat" },
  { name: "long" },
  { name: "duration" },
  { name: "from" },
  { name: "to" },
  { name: "email" },
  { name: "phone" },
  { name: "priority" },
  { name: "pod_signature" },
  { name: "pod_age" },
  { name: "pod_photo" },
  { name: "delivery_note" },
  { name: "vehicle_tags" },
  { name: "driver_tags" },
  { name: "unit_count" },
  { name: "unit_weight" },
  { name: "unit_volume" },
  { name: "unit_id" },
  { name: "unit_note" },
  { name: "tracking_id" }
];

export const requiredFields = {
  type: true,
  street: true,
  postal_code: true,
  country_code: true
};
